import { invokeApi } from "../../bl_libs/invokeApi";

const getAuthHeader = () => ({
  "x-sh-auth": localStorage.getItem("token"),
});

export const getFeedbackList = async ({ status, userType, limit = 50, page = 1 } = {}) => {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (userType) params.set("userType", userType);
  params.set("limit", limit);
  params.set("page", page);

  return invokeApi({
    path: `api/feedback?${params.toString()}`,
    method: "GET",
    headers: getAuthHeader(),
  });
};

export const getFeedbackStats = async () => {
  return invokeApi({
    path: "api/feedback/stats/summary",
    method: "GET",
    headers: getAuthHeader(),
  });
};

export const updateFeedbackStatus = async (id, status, adminNotes) => {
  return invokeApi({
    path: `api/feedback/${id}/status`,
    method: "PATCH",
    headers: getAuthHeader(),
    postData: { status, adminNotes },
  });
};

export const toggleFeedbackRead = async (id, isRead) => {
  return invokeApi({
    path: `api/feedback/${id}/read`,
    method: "PATCH",
    headers: getAuthHeader(),
    postData: { isRead },
  });
};
